// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "dl[data-v-7b458e5b]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-size:1.5rem;line-height:2.2rem}dl dt[data-v-7b458e5b]{font-weight:700;margin-right:2rem}dl.big[data-v-7b458e5b]{font-size:1.8rem}@media (max-width:1199px){dl[data-v-7b458e5b]{font-size:1.3rem}dl.big[data-v-7b458e5b]{font-size:1.5rem}}", ""]);
// Exports
module.exports = exports;
